export const partsExportConfig = {
  entityName: 'Parts',
  filename: 'parts',
  sheetName: 'Parts',
  companyFields: [],
  columns: [
    { header: 'Serial Number', getValue: row => row.serialNumber },
    { header: 'Type', getValue: row => row.specification?.PartType },
    { header: 'Supplier', getValue: row => row.supplier },
    { header: 'Order Number', getValue: row => row.orderNumber },
    { header: 'Order Date', getValue: row => row.orderDate },
    { header: 'Shipping Date', getValue: row => row.shippingDate },
    { header: 'Status', getValue: row => row.reference },
  ],
  filters: [
    { label: 'Part Type', field: 'specification.PartType', type: 'multi-select' },
    { label: 'Status', field: 'reference', type: 'multi-select' },
    { label: 'Supplier', field: 'supplier', type: 'multi-select' },
    { label: 'Location', field: 'location', type: 'multi-select' },
    { label: 'Order Date', field: 'orderDate', type: 'date-range' },
    { label: 'Shipping Date', field: 'shippingDate', type: 'date-range' },
  ],
};
